export const ADD_QUANTITY = 'ADD_QUANTITY'
export const REMOVE_QUANTITY = 'REMOVE_QUANTITY'
export const REMOVE_STORE_MANAGER_REQUEST = 'REMOVE_STORE_MANAGER_REQUEST'
